import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/auth/auth-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/auth/new-password-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/auth/register-activate-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/auth/update-password-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/catalog/catalog-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/dashboard/dashboard-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/dynamic-page/dynamic-page-container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/fe/src/components/containers/homepage/homepage-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/learning-paths/learning-path-by-id/learning-path-by-id-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/profile/change-password/change-password-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/profile/instruments/instruments-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/profile/me/me-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/profile/onboarding/onboarding-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/profile/study-session/study-session-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/profile/subscription/subscription-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/teacher/teacher-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/users/user-container.tsx");
